// PlannerCanvas.js

import React from 'react';
import { Stage, Layer, Text, Rect, Line } from 'react-konva';

export default function PlannerCanvas({ elements, guides, editingText, handleTextChange, handleTextBlur, handleDrag, handleDoubleClick, setSelectedId, stageRef }) {
  return (
    <div style={{ border: '1px solid #ccc', background: '#fff', width: 816, height: 1056, position: 'relative' }}>
      {editingText && (
        <input
          style={{ position: 'absolute', top: editingText.y, left: editingText.x, fontSize: editingText.fontSize, zIndex: 10 }}
          value={editingText.text}
          onChange={handleTextChange}
          onBlur={handleTextBlur}
          autoFocus
        />
      )}
      <Stage width={816} height={1056} ref={stageRef}>
        <Layer>
          {guides.map((g, idx) => (
            <Line key={`guide-${idx}`} points={g.points} stroke="blue" strokeWidth={1} dash={[4, 4]} />
          ))}
          {elements.map((el) => {
            switch (el.type) {
              case 'text':
              case 'checkbox':
                return (
                  <Text
                    key={el.id}
                    x={el.x}
                    y={el.y}
                    text={el.text}
                    fontSize={el.fontSize}
                    draggable
                    onDragMove={(e) => handleDrag(el.id, e)}
                    onDragEnd={() => setSelectedId(null)}
                    onClick={() => setSelectedId(el.id)}
                    onDblClick={() => handleDoubleClick(el)}
                  />
                );
              case 'line':
                return (
                  <Line
                    key={el.id}
                    x={el.x}
                    y={el.y}
                    points={el.points}
                    stroke={el.stroke}
                    strokeWidth={el.strokeWidth}
                    draggable
                    onDragMove={(e) => handleDrag(el.id, e)}
                    onDragEnd={() => setSelectedId(null)}
                    onClick={() => setSelectedId(el.id)}
                  />
                );
              case 'box':
                return (
                  <Rect
                    key={el.id}
                    x={el.x}
                    y={el.y}
                    width={el.width}
                    height={el.height}
                    stroke={el.stroke}
                    strokeWidth={el.strokeWidth}
                    draggable
                    onDragMove={(e) => handleDrag(el.id, e)}
                    onDragEnd={() => setSelectedId(null)}
                    onClick={() => setSelectedId(el.id)}
                  />
                );
              default:
                return null;
            }
          })}
        </Layer>
      </Stage>
    </div>
  );
}
